import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '.';

interface ScopedEnvState {
  [scopeKey: string]: string | undefined;
}

const initialState: ScopedEnvState = {};

export const scopedEnvSlice = createSlice({
  name: 'scopedEnv',
  initialState,
  reducers: {
    setScopedEnv: (
      state,
      action: PayloadAction<{ scopeKey: string; orgId: string | undefined }>,
    ) => {
      const { scopeKey, orgId } = action.payload;
      state[scopeKey] = orgId;
    },
  },
});

export const { setScopedEnv } = scopedEnvSlice.actions;

export const selectScopedEnvOrgId =
  (scopeKey: string) => (state: RootState) =>
    state[scopedEnvSlice.name]?.[scopeKey];

export default scopedEnvSlice.reducer;
